import "./FriosBanners.css";

export default function FriosBanners({ banners, ordem }) {
  if (!banners || banners.length === 0) return null;

  const bannerFood = banners.find(
    (banner) =>
      banner.localizacao === "friosbanner" && banner.ordem === ordem
  );

  if (!bannerFood) return null;

  return (
    <section className="foodpart01-banner">
      <img
        src={bannerFood.imagem}
        alt="Banner promocional"
      />
    </section>
  );
}
